import {
  setUserTypeCookie,
  getUserTypeCookie,
  clearUserTypeCookie,
} from "@/lib/user-type-cookie";

export function useUserType() {
  return {
    setType: setUserTypeCookie,
    getType: getUserTypeCookie,
    clearType: clearUserTypeCookie,
  };
}
